import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getBroadcastRequest } from "../../../Services/Admin/Admin";
import Table from "../../../Extracomponents/Table1";
import { fDateTime } from "../../../../Utils/Date_formate";
import Loader from "../../../../Utils/Loader";
import Content from "../../../components/Contents/Content";

const BroadcastRequest = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const navigate = useNavigate();
  const broadcast_id = location.state?.broadcast_id;

  const [chatMessages, setChatMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchBroadcastRequests();
  }, [currentPage, search]);

  const fetchBroadcastRequests = async () => {
    setIsLoading(true);
    try {
      const data = {
        page: currentPage,
        limit: 10,
        search: search,
        broadcast_id: broadcast_id,
      };
      const response = await getBroadcastRequest(data, token);
      if (response.status) {
        setChatMessages(response.data);
        setTotalRows(response.pagination?.total || 0);
      }
    } catch (error) {
      console.log("Error fetching broadcast requests:", error);
    }
    setIsLoading(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => (currentPage - 1) * 10 + index + 1,
      sortable: false,
      width: "100px",
    },
    {
      name: "Client Name",
      selector: (row) => row.client_name || "N/A",
      sortable: true,
    },
    {
      name: "Client Email",
      selector: (row) => row.client_email || "N/A",
      sortable: true,
    },
    {
      name: "Client Phone",
      selector: (row) => row.client_phone || "N/A",
      sortable: true,
    },

    {
      name: "View Date",
      selector: (row) => fDateTime(row.createdAt) || "N/A",
      sortable: true,
    },
  ];

  return (
    <Content
      Page_title="Broadcast Request"
      backbutton_status={true}
      backbutton_title={"Back"}
      button_status={false}
    >
      <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control ps-5"
                  placeholder="Search requests..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <span className="position-absolute top-50 product-show translate-middle-y">
                  <i className="bx bx-search" />
                </span>
              </div>
            </div>

            {isLoading ? (
              <Loader />
            ) : (
              <Table
                columns={columns}
                data={chatMessages}
                totalRows={totalRows}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            )}
          </div>
      </div>
    </Content>
  );
};

export default BroadcastRequest;
